import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.MyPages {

  export const GetOrders = async (
    page: number
  ): Promise<any> => {
    const encodedPage = encodeURIComponent(page);
    const url = `/mypages/myorderhistory?handler=MyOrderHistory&page=${encodedPage}`;
    return easyfyAxios.get(
      url
    );
  };

  export const GetFavourites = async (
    page: number
  ): Promise<any> => {
    const encodedPage = encodeURIComponent(page);
    const url = `/mypages/myfavourites?handler=MyFavourites&page=${encodedPage}`;
    return easyfyAxios.get(
      url
    );
  };

  export const GetBoughtProducts = async (
    sortOrder: string,
    page: number
  ): Promise<any> => {
    const encodedSortOrder = encodeURIComponent(sortOrder);
    const encodedPage = encodeURIComponent(page);
    const url = `/mypages/myboughtproducts?handler=MyBoughtProducts&sortOrder=${encodedSortOrder}&page=${encodedPage}`;
    return easyfyAxios.get(
      url
    );
  };
}

export default Easyfy.Web.Services.MyPages;
